<section class="col-12 col-md-12">
    <div class="modal-body body-Div" [innerHtml]="emailConsentText">

    </div>
    <section class="col-12 col-md-12 footer-Sec">
        <button class="col-4 col-md-4 btn not-now" (click)="onRegister()">{{acceptBtnText}}</button>
        <button class="col-4 col-md-4 btn register" (click)="onNotNow()">{{rejectBtnText}}
    </button>
    </section>
</section>